import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import TagManager from 'react-gtm-module'

const usePageTracking = () => {
  const location = useLocation()

  const trackPage = (path) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: path,
      },
    })
  }

  useEffect(() => {
    // Track the current page
    trackPage(location.pathname + location.search)
  }, [location])
}

export default usePageTracking
